export default "__VITE_ASSET__Cn4CLwZn__"